/**
 * LINE Notification Service for Smood Funding (Expense Tracker)
 * Sends Flex Message notifications via the sendSmoodFundingNotification Cloud Function.
 */

import { app } from '../firebaseConfig';
import { getFunctions, httpsCallable } from 'firebase/functions';
import type { NotificationType } from '../types/notifications';

const functions = getFunctions(app);

/**
 * Send a Smood Funding notification to a user via LINE.
 * Resolves false (never throws) when the user has no LINE account linked,
 * has notifications disabled, or the call fails.
 */
export const sendSmoodFundingNotification = async (
  userId: string,
  notificationType: NotificationType | string,
  title: string,
  message: string,
  projectName?: string,
  itemName?: string,
  language?: 'th' | 'en'
): Promise<boolean> => {
  try {
    const sendNotification = httpsCallable(functions, 'sendSmoodFundingNotification');
    const result = await sendNotification({ userId, notificationType, title, message, projectName, itemName, language });
    return (result.data as { success: boolean }).success;
  } catch {
    return false;
  }
};
